var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "390px",
    height: "390px",
    viewBox: "0 0 390 390",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24BCD80D-E3C2-4B1F-87CC-9FA43EEDB4D8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen-/-Intro-/-Push"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 390,
    height: 844
  }), /*#__PURE__*/React.createElement("g", {
    id: "Screen-/-illustration-/-Benutzergruppe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,69 L335,69 C346.045695,69 355,77.954305 355,89 L355,369 C355,380.045695 346.045695,389 335,389 L55,389 C43.954305,389 35,380.045695 35,369 L35,89 C35,77.954305 43.954305,69 55,69 Z",
    id: "Rectangle",
    fill: "#C2F1EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_push_notifications_im0o",
    transform: "translate(19.500000, 59.566250)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.398505,164.007665 C100.862483,167.47627 100.780215,173.145772 104.214105,176.715515 L161.303631,235.802826 C162.980567,237.538349 165.283585,238.528685 167.696801,238.552414 C170.110017,238.575302 172.431735,237.629635 174.14188,235.926826 L348.347429,62.4758709 C350.274583,60.5565686 351.231813,57.8695503 350.952191,55.1641006 C350.672569,52.4586509 349.18601,50.0242108 346.907046,48.5396327 L278.405854,3.92275848 C274.875492,1.59947546 270.20162,2.05952815 267.191986,5.02654784 L104.398505,164.007665 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54189,51.1744766 C349.196196,51.7052093 348.795858,52.1982699 348.347429,52.6455868 L174.551475,229.37332 C172.84133,231.076129 170.519612,232.021796 168.106396,231.998487 C165.69318,231.975179 163.390162,230.984843 161.713226,229.249319 L103.394914,167.70443 C102.997586,167.291548 102.64072,166.841557 102.329205,166.360622 C100.092816,169.801327 101.249389,173.647385 104.214105,176.715523 L161.303631,235.802826 C162.980567,237.538349 165.283585,238.528685 167.696801,238.552414 C170.110017,238.575302 172.431735,237.629635 174.14188,235.926826 L348.347429,62.4758709 C351.369101,59.4657184 351.867534,54.749795 349.54189,51.1744766 L349.54189,51.1744766 Z",
    id: "Path",
    fill: "#C2F1EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.412253,53.3122029 L326.32314,48.7922792 C327.860746,51.5321383 327.306153,54.9704106 324.985064,57.0878631 C322.663975,59.2053155 319.189365,59.4427507 316.601808,57.6607274 L270.727149,26.1218992 C268.599535,24.6615668 267.490662,22.1160131 267.87024,19.5635177 C268.249819,17.0110224 270.051422,14.8982825 272.511903,14.1202406 L268.859542,11.7915691 C267.882987,11.1689207 266.604247,11.312588 265.790204,12.1364114 L111.464546,163.796748 C110.999407,164.267479 110.74377,164.905907 110.755092,165.567575 C110.767184,166.229243 111.045246,166.858228 111.526747,167.312209 L167.574058,221.923964 C168.540004,222.834676 170.054615,222.813639 170.994895,221.876451 L333.825949,57.1250342 C334.35415,56.5985669 334.614719,55.8607346 334.534275,55.1193215 C334.453831,54.3779083 334.041078,53.7131319 333.412253,53.3122029 L333.412253,53.3122029 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6EAEF",
    points: "155.296767 130.308608 202.639005 174.94547 315.245729 63.6912298 258.096962 26.4938444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.869069,91.1479301 C311.517525,91.7667251 312.537787,91.7667251 313.186243,91.1479301 L323.03373,81.3006478 C323.672121,80.6602442 323.672121,79.624078 323.03373,78.9836744 C322.385273,78.3648836 321.365014,78.3648836 320.716556,78.9836744 L310.869069,88.8309608 C310.230679,89.471363 310.230679,90.5075279 310.869069,91.1479301 L310.869069,91.1479301 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.280465,107.736735 C294.920944,108.375131 295.957159,108.375131 296.597639,107.736735 L306.445126,97.8892481 C307.083394,97.2491041 307.082634,96.2129794 306.443427,95.5737724 C305.80422,94.9345654 304.768096,94.9338054 304.127952,95.572074 L294.280465,105.419561 C293.641871,106.059959 293.641871,107.096337 294.280465,107.736735 L294.280465,107.736735 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8D99AE",
    cx: 156.390095,
    cy: 168.623217,
    r: 11.0590696
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#394854",
    points: "263.449143 239.239624 28.3083374 239.239624 28.3083374 238.346297 263.610933 238.346297"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6EAEF",
    x: 120.177986,
    y: 73.0602729,
    width: 116.902357,
    height: 23.0807247
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6EAEF",
    x: 120.177986,
    y: 36.5901647,
    width: 116.902357,
    height: 23.0807165
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6EAEF",
    x: 120.177986,
    y: 0,
    width: 116.902357,
    height: 23.0807165
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "122.670107 20.5884815 234.58826 20.5884815 234.58826 2.49218182 122.670107 2.49218182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "122.670107 57.2591439 234.58826 57.2591439 234.58826 39.1628442 122.670107 39.1628442"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "122.670086 93.6487871 234.588239 93.6487871 234.588239 75.5524875 122.670086 75.5524875"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C2F1EA",
    cx: 132.467718,
    cy: 11.3904853,
    r: 6.89423628
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C2F1EA",
    x: 148.953944,
    y: 8.69274,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C2F1EA",
    x: 148.953944,
    y: 12.589481,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7D3DE",
    cx: 132.467718,
    cy: 48.2803959,
    r: 6.89423628
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7D3DE",
    x: 148.953944,
    y: 45.5826505,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7D3DE",
    x: 148.953944,
    y: 49.4793956,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7D3DE",
    cx: 132.467718,
    cy: 84.7505164,
    r: 6.89424038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7D3DE",
    x: 148.953944,
    y: 82.0527669,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7D3DE",
    x: 148.953944,
    y: 85.9495161,
    width: 68.0431499,
    height: 1.49874969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24376712,241.957661 L8.25958359,242.311834 C10.6417236,243.748075 13.4376857,244.288741 16.534299,244.178682 C17.4138087,244.152333 18.2135977,243.662205 18.6363414,242.890505 L18.6363414,242.890505 C19.0017659,242.216052 19.031543,241.409711 18.7168593,240.710142 C18.4021756,240.010573 17.7790779,239.497911 17.0319899,239.323894 L14.7404482,238.790151 L9.21095439,233.382118 L5.8751294,227.344853 L1.02957757,227.900563 L0.0208388766,235.569004 L0.0208388766,235.569004 C-0.245160402,238.758353 2.06519001,241.584361 5.24376712,241.957661 L5.24376712,241.957661 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2137615,238.078057 L55.1695846,238.77355 C57.3725717,240.471854 60.088712,241.327564 63.1777068,241.571044 C64.0544923,241.645086 64.904923,241.249282 65.412843,240.530774 L65.412843,240.530774 C65.8527335,239.902348 65.974189,239.104651 65.7412612,238.373783 C65.5083335,237.642915 64.9477041,237.062598 64.2253078,236.804593 L62.0095045,236.013235 L57.1321885,230.010384 L54.5059544,223.632344 L49.6286303,223.632344 L47.7527417,231.135906 L47.7527417,231.135906 C47.1250827,234.274186 49.0984071,237.345034 52.2137615,238.078057 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6369102,224.056615 L49.1213876,224.905157 L40.4238349,180.993114 L25.3622013,155.324719 L7.11856204,229.996409 L0.330226589,231.269221 C1.09142235,189.218723 -2.62387208,136.2791 5.84574914,129.868461 L42.7573231,134.11117 L58.8796116,177.386809 L54.6369102,224.056615 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 27.9078393,
    cy: 51.802603,
    r: 12.728129
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "10.0883154 71.3191207 25.3621193 73.8647547 29.1807751 60.2879036 18.149558 56.893998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72439431,131.565545 L44.454407,135.383983 C41.1891143,124.029841 38.1974312,112.715631 40.6359683,101.442306 C43.7325979,91.3779137 40.7437205,85.3929173 32.57482,80.6530287 L27.0592974,68.3491707 L12.2098341,66.6520868 L12.2098341,66.6520868 C8.27742339,72.9747349 6.66883325,80.4691744 7.66024755,87.8486615 C9.77611381,103.895888 9.20472854,118.786802 3.72439431,131.565545 Z",
    id: "Path",
    fill: "#C8D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9028198,37.3577296 C27.2498001,37.0574308 32.2756926,36.9745738 32.9050684,38.1195398 C37.4064456,37.9090079 41.3267833,39.4792483 43.1350313,43.1333001 C43.4476532,43.7737702 43.4605203,44.519819 43.1701701,45.1706886 C42.8798199,45.8215581 42.3160799,46.310385 41.6306497,46.5056282 C39.3471157,47.1640074 35.8665029,47.9784915 33.3269268,47.7183985 C28.0526353,53.9192229 30.2717933,65.2288665 35.3912865,71.8360749 L30.7650974,72.7843368 L21.9865554,60.5593095 L24.7565411,74.015969 L14.0736764,75.7632774 L10.3477243,58.6621917 C9.56433684,54.6029527 9.76040192,50.4154086 10.9196462,46.4471257 C11.0434873,46.0463759 11.1928862,45.6539754 11.3669241,45.2723371 C13.4633878,40.7128113 17.8943117,37.67282 22.9028198,37.3577296 L22.9028198,37.3577296 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0291942,144.293674 L29.7477695,154.143618 C29.6672876,156.960457 31.7776855,159.360442 34.5816889,159.640844 L34.5816889,159.640844 C36.3389521,159.81657 38.0702958,159.11713 39.2123871,157.770104 C40.3544783,156.423077 40.7613268,154.600649 40.3005549,152.895791 L38.0903302,144.717953 L31.726278,109.927725 L32.150549,89.562719 L18.5738781,89.138448 L21.1195121,112.04908 L30.0291942,144.293674 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7253362,91.2598028 C22.6442188,89.3862248 28.0802083,89.3862248 32.9990909,91.2598028 L32.150549,74.2889601 C32.150549,70.5398698 29.111312,67.5006288 25.3622217,67.5006288 L25.3622217,67.5006288 C21.6131315,67.5006288 18.5738945,70.5398698 18.5738945,74.2889601 L17.7253362,91.2598028 Z",
    id: "Path",
    fill: "#C8D7F2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/push.23c4063ff278a9b7c454b23396f483ba.svg";
export { ForwardRef as ReactComponent };